import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaPlay } from 'react-icons/fa';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

const testimonials = [
  {
    id: 1,
    video: "https://player.vimeo.com/video/380443962",
    thumbnail: "https://vumbnail.com/380443962.jpg",
    text: "I found Maxiom Wealth Equity Investment Advisory very Fascinating because of the value it is delivering, Maxiom Wealth is helping me to beat the markets and get more returns",
    name: "Mr. Harilal Neelakantan",
    designation: "Business Leader"
  },
  {
    id: 2,
    video: "https://player.vimeo.com/video/458848054",
    thumbnail: "https://vumbnail.com/458848054.jpg",
    text: "I have been very impressed with Maxiom Wealth Performance, Rebalancing, The Diligence in picking up the stocks.. is very critical and also I Love the model where there is flexibility",
    name: "Mr. Ramesh Menon",
    designation: "SVP & CFO - Asia, Synchrony"
  },
  {
    id: 3,
    video: "https://player.vimeo.com/video/481054728",
    thumbnail: "https://vumbnail.com/481054728.jpg",
    text: "You should not be working for money, money should work for you. I trust Maxiom Wealth because it is giving me good returns, service, personal attention. I am very satisfied and happy.",
    name: "Mr. Suman Sasmal",
    designation: "Ambassador, Coach"
  },
  {
    id: 4,
    video: "https://player.vimeo.com/video/381501489",
    thumbnail: "https://vumbnail.com/381501489.jpg",
    text: "I was impressed with the Maxiom Wealth product mainly because of No Hidden-cost, No Entry or Exit Loads, I am happy with my returns, I recommend this to any investor..",
    name: "Mr. Nageswera Rao Vasireddy",
    designation: "Sales Leader, Pharma Industry"
  },
  {
    id: 5,
    video: "https://player.vimeo.com/video/380209697?h=ce88c9e4d8",
    thumbnail: "https://jamaappprod.s3.ap-south-1.amazonaws.com/jama_wealth_website/img/vimeo_client_review_1.png",
    text: "Maxiom Wealth Equity Investment Advisory goes through various backtesting and performance, i do get a sense of comfort and confidence while investing.",
    name: "Mr. Ravi S Rao",
    designation: "Managing Director and Member"
  }
];

const PrevArrow = (props) => (
  <button 
    className="absolute top-1/2 -translate-y-1/2 z-10 bg-white/90 rounded-full w-12 h-12 flex items-center justify-center cursor-pointer shadow-md -left-6 hover:bg-white transition-all duration-300 lg:w-12 lg:h-12 md:w-10 md:h-10 md:-left-5" 
    onClick={props.onClick}
  >
    <IoIosArrowBack className="text-[#113262] text-2xl md:text-xl" />
  </button>
);

const NextArrow = (props) => (
  <button 
    className="absolute top-1/2 -translate-y-1/2 z-10 bg-white/90 rounded-full w-12 h-12 flex items-center justify-center cursor-pointer shadow-md -right-6 hover:bg-white transition-all duration-300 lg:w-12 lg:h-12 md:w-10 md:h-10 md:-right-5" 
    onClick={props.onClick}
  >
    <IoIosArrowForward className="text-[#113262] text-2xl md:text-xl" />
  </button>
);

const ClientTestimonials = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    arrows: true,
    cssEase: "cubic-bezier(0.87, 0, 0.13, 1)",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          arrows: true,
          speed: 600
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          arrows: true,
          speed: 400
        }
      }
    ]
  };

  const handlePlayVideo = (videoId) => {
    setActiveVideo(videoId);
  };

  return (
    <section className="py-8 bg-[#F5F5F5] relative overflow-hidden">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <h2 className="text-center text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-12 md:mb-16 lg:mb-20 font-bold relative tracking-[3px] md:tracking-[2px]">
          What Our Clients Say
        </h2>
        
        <div className="slick-container">
          <Slider {...settings}>
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="px-2">
                <div className="flex flex-col h-[550px] p-6 mx-2 bg-white/95 rounded-2xl shadow-lg backdrop-blur-md">
                  <div className="relative w-full aspect-video mb-6 rounded-xl overflow-hidden bg-black shadow-md">
                    {activeVideo === testimonial.id ? (
                      <iframe
                        title="vimeo-player"
                        src={`${testimonial.video}?h=5e459251cd&autoplay=1&title=0&byline=0&portrait=0`}
                        allow="autoplay; fullscreen"
                        allowFullScreen
                        className="absolute top-0 left-0 w-full h-full border-none"
                      />
                    ) : (
                      <div 
                        className="absolute top-0 left-0 w-full h-full bg-cover bg-center cursor-pointer" 
                        style={{ backgroundImage: `url(${testimonial.thumbnail})` }}
                      >
                        <button 
                          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-100 bg-[rgba(28,82,160,0.9)] rounded-full w-16 h-16 flex items-center justify-center cursor-pointer shadow-md hover:scale-110 transition-all duration-300"
                          onClick={() => handlePlayVideo(testimonial.id)}
                        >
                          <FaPlay className="text-white text-3xl ml-1" />
                        </button>
                      </div>
                    )}
                  </div>
                  
                  <div className="flex flex-col flex-1">
                    <div className="flex-1">
                      <p className="text-[#262626] text-lg leading-relaxed relative pl-6 italic">
                        <span className="absolute left-0 top-0 text-4xl text-[#F49611] font-serif leading-none">"</span>
                        {testimonial.text}
                      </p>
                    </div>
                    
                    <div className="border-t border-black/10 pt-4 mt-4">
                      <h4 className="text-[#113262] text-xl font-semibold m-0 mb-1">{testimonial.name}</h4>
                      <p className="text-[#8A8A8A] text-base m-0">{testimonial.designation}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default ClientTestimonials;